import React from 'react';
import { EmailCorrespondence } from '../api/claims';
import { EmailBody } from '../utils/EmailBody';
import './EmailViewer.css';

interface EmailViewerProps {
  email: EmailCorrespondence;
  onClose: () => void;
}

const EmailViewer: React.FC<EmailViewerProps> = ({ email, onClose }) => {
  return (
    <div className="email-viewer-overlay" onClick={onClose}>
      <div className="email-viewer-modal" onClick={(e) => e.stopPropagation()}>
        <div className="email-viewer-header">
          <h3>{email.subject || '(No subject)'}</h3>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        
        <div className="email-viewer-meta">
          <div className="meta-row">
            <strong>From:</strong> {email.from}
          </div>
          <div className="meta-row">
            <strong>To:</strong> {email.to.join(', ')}
          </div>
          {email.cc && email.cc.length > 0 && (
            <div className="meta-row">
              <strong>CC:</strong> {email.cc.join(', ')}
            </div>
          )}
          <div className="meta-row">
            <strong>Date:</strong> {new Date(email.timestamp).toLocaleString()}
          </div>
          <div className="meta-row">
            <strong>Direction:</strong> 
            <span className={`direction-badge ${email.direction}`}>
              {email.direction === 'sent' ? '↗️ Sent' : '↘️ Received'}
            </span>
          </div>
        </div>
        
        <div className="email-viewer-body">
          {email.body ? (
            <EmailBody body={email.body} />
          ) : (
            <pre className="email-content-text">{email.bodyPreview}</pre>
          )}
          {email.hasAttachments && (
            <div className="attachments-notice">
              📎 This email has attachments
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmailViewer;